<template>
	<details ref="menu" class="ai-download-menu">
		<summary class="ai-download-trigger"><slot></slot></summary>
		<div class="ai-download-options" :class="{ 'ai-download-options--above': placement === 'above' }" aria-label="选择电脑版本">
			<button type="button" class="ai-download-item" @click="downloadVersion(downloads.mac)">
				<span class="ai-download-platform-icon">
					<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
						<path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.3.03-1.72-.79-3.2-.79-1.49 0-1.95.77-3.18.82-1.31.05-2.3-1.32-3.14-2.53-1.71-2.48-3.05-7-1.28-10.06.87-1.52 2.46-2.48 4.17-2.51 1.3-.03 2.53.87 3.2.87.64 0 2.14-1.08 3.61-.92.62.03 2.35.25 3.46 1.88-.09.06-2.07 1.22-2.05 3.63.03 2.88 2.52 3.84 2.55 3.85-.02.07-.4 1.37-1.31 2.79M14.1 4.98c.71-.86 1.2-2.06 1.07-3.25-1.03.04-2.28.69-3.02 1.55-.66.76-1.24 1.98-1.09 3.14 1.15.09 2.33-.58 3.04-1.44Z" />
					</svg>
				</span>
				<strong>Mac 通用版</strong>
				<span v-if="currentVersion === 'mac'" class="ai-download-current">当前设备</span>
			</button>
			<button type="button" class="ai-download-item" @click="downloadVersion(downloads.windows)">
				<span class="ai-download-platform-icon">
					<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">
						<path d="M2.5 2.5h8.25v8.25H2.5V2.5Zm10.75 0h8.25v8.25h-8.25V2.5ZM2.5 13.25h8.25v8.25H2.5v-8.25Zm10.75 0h8.25v8.25h-8.25v-8.25Z" />
					</svg>
				</span>
				<strong>Windows 10/11 版</strong>
				<span v-if="currentVersion === 'windows'" class="ai-download-current">当前设备</span>
			</button>
		</div>
	</details>
</template>

<script>
export default {
	name: 'AiDownloadMenu',
	props: {
		downloads: {
			type: Object,
			required: true,
		},
		placement: {
			type: String,
			default: 'below',
		},
	},
	data() {
		return {
			currentVersion: null,
		}
	},
	mounted() {
		this.currentVersion = this.detectCurrentVersion()
		document.addEventListener('click', this.closeOnOutsideClick)
		document.addEventListener('keydown', this.closeOnEscape)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.closeOnOutsideClick)
		document.removeEventListener('keydown', this.closeOnEscape)
	},
	methods: {
		detectCurrentVersion() {
			const platform = String(navigator.platform || '').toLowerCase()
			const userAgent = navigator.userAgent.toLowerCase()
			const isIPadOS =
				userAgent.includes('ipad') ||
				userAgent.includes('iphone') ||
				userAgent.includes('ipod') ||
				((platform.includes('mac') || userAgent.includes('macintosh')) && navigator.maxTouchPoints > 1)

			if (isIPadOS) return null
			if (platform.includes('mac') || userAgent.includes('macintosh')) return 'mac'
			if (platform.includes('win') || userAgent.includes('windows')) return 'windows'
			return null
		},
		downloadVersion(url) {
			this.closeMenu()
			const link = document.createElement('a')
			link.href = url
			link.referrerPolicy = 'no-referrer'
			link.rel = 'noopener noreferrer'
			document.body.appendChild(link)
			link.click()
			link.remove()
		},
		closeMenu() {
			if (this.$refs.menu) this.$refs.menu.removeAttribute('open')
		},
		closeOnOutsideClick(event) {
			if (this.$refs.menu && this.$refs.menu.open && !this.$el.contains(event.target)) this.closeMenu()
		},
		closeOnEscape(event) {
			if (event.key !== 'Escape' || !this.$refs.menu || !this.$refs.menu.open) return
			this.closeMenu()
			const trigger = this.$refs.menu.querySelector('summary')
			if (trigger) trigger.focus()
		},
	},
}
</script>

<style lang="scss" scoped>
.ai-download-menu {
	position: relative;
	display: inline-block;
	width: max-content;
}

.ai-download-trigger {
	list-style: none;
}

.ai-download-trigger::-webkit-details-marker {
	display: none;
}

.ai-download-options {
	position: absolute;
	top: calc(100% + 10px);
	left: 50%;
	z-index: 3000;
	display: grid;
	width: min(280px, calc(100vw - 24px));
	box-sizing: border-box;
	gap: 2px;
	padding: 10px;
	border: 1px solid rgba(33, 29, 45, 0.08);
	border-radius: 22px;
	background: #ffffff;
	box-shadow: 0 20px 55px rgba(38, 31, 68, 0.18);
	transform: translateX(-50%);
	animation: download-menu-in 150ms ease-out both;
}

.ai-download-menu:not([open]) > .ai-download-options {
	display: none;
}

.ai-download-options--above {
	top: auto;
	bottom: calc(100% + 10px);
}

.ai-download-item {
	display: flex;
	width: 100%;
	min-height: 52px;
	align-items: center;
	gap: 11px;
	box-sizing: border-box;
	padding: 0 13px;
	border: 0;
	border-radius: 13px;
	background: transparent;
	color: #211d2d;
	font: inherit;
	text-align: left;
	cursor: pointer;
	transition: background 140ms ease;
}

.ai-download-item:hover {
	background: #f6f5f8;
}

.ai-download-item:focus-visible {
	outline: 3px solid rgba(10, 173, 245, 0.28);
	outline-offset: -2px;
}

.ai-download-platform-icon {
	display: grid;
	width: 25px;
	flex: 0 0 auto;
	place-items: center;
	color: #211d2d;
}

.ai-download-platform-icon svg {
	display: block;
	width: 24px;
	height: 24px;
	fill: currentColor;
}

.ai-download-item strong {
	min-width: 0;
	flex: 1;
	font-size: 17px;
	font-weight: 700;
	line-height: 1.3;
}

.ai-download-current {
	flex: 0 0 auto;
	color: #4c69f6;
	font-size: 12px;
	font-weight: 700;
}

@keyframes download-menu-in {
	from { opacity: 0; }
	to { opacity: 1; }
}

@media (max-width: 640px) {
	.ai-download-options { border-radius: 19px; }
	.ai-download-item { min-height: 50px; }
}

@media (prefers-reduced-motion: reduce) {
	.ai-download-options { animation: none; }
}
</style>
